import { CogIcon, QuestionMarkCircleIcon, MegaphoneIcon } from '@heroicons/react/24/outline';
import { useUserContext } from '../../providers/UserProvider';
import { useFirmContext } from '../../providers/FirmProvider';
import { Link } from 'react-router-dom';

import { SubscriptionStatus } from '../../types/firm';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';
import ProfileIcon from './ProfileIcon';
import NotificationIcon from '../notification/NotificationIcon';
import FirmNavbar from '../firm-navbar/FirmNavbar';
import { ReactComponent as WorkpapersLogo } from '../../assets/workpapers-logo.svg';

import TrialAction from './TrialAction';
import GlobalSearch from '../global-search/GlobalSearch';
import { useIntercom } from 'react-use-intercom';

function TopNavbar(): JSX.Element {
    const { firstName, lastName, avatarUrl, profileHexColour } = useUserContext();
    const firm = useFirmContext();
    const { isExternalUser } = useIsFirmRole();
    const { showNewMessage, showSpace } = useIntercom();

    return (
        <nav className="flex items-center w-full bg-indigo-700 h-[var(--navbar-height)] dark:bg-gray-800 dark:border-b dark:border-white/[0.07] px-4">
            <Link to={`/${firm.shortId}/dashboard`} className="w-[150px] flex gap-x-2 mr-8">
                <div className="text-white dark:text-indigo-400">
                    <WorkpapersLogo className="w-[150px]" />
                </div>
            </Link>
            <FirmNavbar />
            <section className="ml-auto flex gap-8 items-center shrink-0 relative pl-24">
                {firm.subscription?.status === SubscriptionStatus.TRIALING && <TrialAction />}
                <GlobalSearch />
                <section className="flex items-center gap-4 ml-4">
                    <button onClick={(): void => showNewMessage()}>
                        <MegaphoneIcon className="h-5 w-5 text-white" />
                    </button>

                    <button onClick={(): void => showSpace('help')}>
                        <QuestionMarkCircleIcon className="text-white dark:text-gray-200 h-5 w-5" />
                    </button>
                    <div className="mt-1.5">
                        <NotificationIcon />
                    </div>
                    {!isExternalUser && (
                        <Link data-intercom-target="header-settings-button" to={`/${firm.shortId}/settings`}>
                            <CogIcon className="text-white dark:text-gray-200 h-5 w-5" />
                        </Link>
                    )}
                </section>
                <ProfileIcon firstName={firstName} lastName={lastName} avatarUrl={avatarUrl} profileHexColour={profileHexColour} />
            </section>
        </nav>
    );
}

export default TopNavbar;
